export { useIsMobile } from '@wix/bex-core/react';
